var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("admin-preloader", { attrs: { show: _vm.loading } }),
      _vm._v(" "),
      _c("admin-breadcrumb", {
        attrs: {
          items: [
            {
              text: "Reports",
              path: { name: "admin-reports" },
            },
          ],
          name: "Public Menu Sharing",
          title: _vm.pageTitle,
        },
      }),
      _vm._v(" "),
      _c(
        "admin-panel",
        {
          attrs: { "with-header": "" },
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-between align-items-center",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex flex-wrap align-items-center" },
                        [
                          _c(
                            "div",
                            { staticClass: "mr-3 my-1" },
                            [
                              _c("strong", { staticClass: "text-uppercase" }, [
                                _vm._v(
                                  "\n              Start Date:\n            "
                                ),
                              ]),
                              _vm._v(
                                "\n\n            " +
                                  _vm._s(_vm.startDate) +
                                  "\n\n            "
                              ),
                              _c("b-form-datepicker", {
                                staticClass: "ml-2",
                                attrs: {
                                  max: _vm.maxDate,
                                  "button-only": "",
                                  "button-variant": "primary",
                                  "reset-button": "",
                                },
                                on: { input: _vm.onStartDateChanged },
                                model: {
                                  value: _vm.filters.start_date,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filters, "start_date", $$v)
                                  },
                                  expression: "filters.start_date",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "my-1" },
                            [
                              _c("strong", { staticClass: "text-uppercase" }, [
                                _vm._v(
                                  "\n              End Date:\n            "
                                ),
                              ]),
                              _vm._v(
                                "\n\n            " +
                                  _vm._s(_vm.endDate) +
                                  "\n\n            "
                              ),
                              _c("b-form-datepicker", {
                                staticClass: "ml-2",
                                attrs: {
                                  max: _vm.maxDate,
                                  "button-only": "",
                                  "button-variant": "primary",
                                  "reset-button": "",
                                },
                                on: { input: _vm.onEndDateChanged },
                                model: {
                                  value: _vm.filters.end_date,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filters, "end_date", $$v)
                                  },
                                  expression: "filters.end_date",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-flex" },
                        [
                          _c(
                            "b-btn",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true },
                                },
                              ],
                              staticClass: "mr-2",
                              attrs: {
                                variant: "primary",
                                title: "Download CSV",
                                disabled: !_vm.reportRows.length,
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.downloadCsv.apply(null, arguments)
                                },
                              },
                            },
                            [_c("b-icon-download")],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-btn",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true },
                                },
                              ],
                              attrs: {
                                variant: "primary",
                                title: "Reset Filters",
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.resetFilters.apply(null, arguments)
                                },
                              },
                            },
                            [_c("b-icon-arrow-counterclockwise")],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "header-right",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass: "mt-n2 d-flex flex-wrap align-items-center",
                    },
                    [
                      _c(
                        "b-input-group",
                        { staticClass: "mr-2 my-2 public-menu-sharing-search" },
                        [
                          _c("b-form-input", {
                            attrs: { placeholder: "Company, user or email" },
                            on: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.loadReportData.apply(null, arguments)
                              },
                            },
                            model: {
                              value: _vm.filters.search,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.filters,
                                  "search",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "filters.search",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "b-input-group-append",
                            [
                              _c(
                                "b-btn",
                                {
                                  attrs: { variant: "primary" },
                                  on: { click: _vm.loadReportData },
                                },
                                [_vm._v("\n              Search\n            ")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("b-form-select", {
                        staticClass: "w-auto mr-2 my-2",
                        attrs: { options: _vm.stateOptions },
                        on: { change: _vm.loadReportData },
                        model: {
                          value: _vm.filters.state,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "state", $$v)
                          },
                          expression: "filters.state",
                        },
                      }),
                      _vm._v(" "),
                      _c("b-form-select", {
                        staticClass: "w-auto mr-2 my-2",
                        attrs: { options: _vm.statusOptions },
                        on: { change: _vm.loadReportData },
                        model: {
                          value: _vm.filters.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "status", $$v)
                          },
                          expression: "filters.status",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("b-table", {
            attrs: {
              fields: _vm.reportColumns,
              items: _vm.reportRows,
              "table-class": "text-nowrap",
              responsive: "",
              hover: "",
              "show-empty": "",
              "empty-text": "No public menu sharing records found",
            },
            scopedSlots: _vm._u([
              {
                key: "cell(company)",
                fn: function (data) {
                  return [
                    _c("div", { staticClass: "font-weight-bold" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(data.item.company_name || "—") +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    data.item.state
                      ? _c("div", { staticClass: "small text-muted" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(data.item.state) +
                              "\n        "
                          ),
                        ])
                      : _vm._e(),
                  ]
                },
              },
              {
                key: "cell(user)",
                fn: function (data) {
                  return [
                    _c("div", [
                      _vm._v(
                        "\n          " +
                          _vm._s(data.item.shared_by || "—") +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "small text-muted" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(data.item.shared_by_email || "—") +
                          "\n        "
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "cell(menu)",
                fn: function (data) {
                  return [
                    _c("div", { staticClass: "font-weight-bold" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(data.item.menu_name || "—") +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "small text-muted" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            data.item.menu_type === "company"
                              ? "Company Menu"
                              : "Brand Menu"
                          ) +
                          "\n        "
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "cell(public_url)",
                fn: function (data) {
                  return [
                    data.item.status === "active" && data.item.public_url
                      ? _c(
                          "b-link",
                          {
                            attrs: {
                              href: data.item.public_url,
                              target: "_blank",
                              rel: "noopener noreferrer",
                            },
                          },
                          [
                            _vm._v("\n          Open Menu\n          "),
                            _c("b-icon-box-arrow-up-right", {
                              staticClass: "ml-1",
                              attrs: { "font-scale": "0.8" },
                            }),
                          ],
                          1
                        )
                      : _c("span", { staticClass: "text-muted" }, [
                          _vm._v("\n          —\n        "),
                        ]),
                  ]
                },
              },
              {
                key: "cell(status)",
                fn: function (data) {
                  return [
                    _c(
                      "b-badge",
                      {
                        attrs: {
                          variant: _vm.getStatusVariant(data.item.status),
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.getStatusLabel(data.item.status)) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "head(first_shared_at)",
                fn: function (data) {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "sortable-column",
                        on: {
                          click: function ($event) {
                            return _vm.toggleSort("first_shared_at")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(data.label) +
                            "\n          " +
                            _vm._s(_vm.renderSortIcon("first_shared_at")) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "head(last_shared_at)",
                fn: function (data) {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "sortable-column",
                        on: {
                          click: function ($event) {
                            return _vm.toggleSort("last_shared_at")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(data.label) +
                            "\n          " +
                            _vm._s(_vm.renderSortIcon("last_shared_at")) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "cell(first_shared_at)",
                fn: function (data) {
                  return [
                    _c("div", [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.formatDate(data.item.first_shared_at)) +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "small text-muted" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.formatTime(data.item.first_shared_at)) +
                          "\n        "
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "cell(last_shared_at)",
                fn: function (data) {
                  return [
                    _c("div", [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.formatDate(data.item.last_shared_at)) +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "small text-muted" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.formatTime(data.item.last_shared_at)) +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    data.item.generated_by &&
                    data.item.generated_by !== data.item.shared_by
                      ? _c("div", { staticClass: "small text-muted mt-1" }, [
                          _vm._v(
                            "\n          by " +
                              _vm._s(data.item.generated_by) +
                              "\n        "
                          ),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }